function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import localeKeys from '../../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import clone from 'ramda/src/clone';
import { STORE_GRID_ACTIONS } from './store.inventory.search.constants';
import { IsFetchingSelector } from '../../../../reducers/selectors/offering.order.selectors';
var StoreInventorySearchController = /*#__PURE__*/function () {
  function StoreInventorySearchController($scope, $ngRedux, $timeout, uiGridConstants) {
    var _this = this;
    _classCallCheck(this, StoreInventorySearchController);
    // NOTE: Seek UX approval for custom modal dimensions
    var MODAL_CUSTOM_DIMENSIONS = {
      HEIGHT: '65vh',
      WIDTH: '960px'
    };

    /*
        Can just use normal index
        https://stackoverflow.com/questions/29637188/how-to-get-row-index-in-angular-ui-grid-3-0
    */

    Object.assign(this, {
      $ngRedux: $ngRedux,
      CoreLocaleKeys: CoreLocaleKeys,
      addLastColumn: this.addLastColumn.bind(this),
      cannotGetNextBatchOfStores: this.cannotGetNextBatchOfStores.bind(this),
      cannotGetPreviousBatchOfStores: this.cannotGetPreviousBatchOfStores.bind(this),
      getNextBatchOfStores: this.getNextBatchOfStores.bind(this),
      getPreviousBatchOfStores: this.getPreviousBatchOfStores.bind(this),
      changeColumnDefs: this.changeColumnDefs.bind(this),
      MODAL_CUSTOM_DIMENSIONS: MODAL_CUSTOM_DIMENSIONS,
      selectStore: this.selectStore.bind(this),
      setAssociatedTableData: this.setAssociatedTableData.bind(this),
      onRegionChanged: this.onRegionChanged.bind(this),
      updateStoreGridColumns: this.updateStoreGridColumns.bind(this)
    });
    var onRegisterApi = function onRegisterApi(event) {
      _this.gridApi = event.grid.api;
    };
    var gridOptions = {
      //          selectionRowHeaderWidth: 20,
      columnDefs: [{
        cellClass: 'first-column c-inventoryDetails',
        cellTemplate: require('./customCellTemplates/availability.cell.template.html'),
        field: 'physicalInventoryItem',
        firstColumn: true,
        headerCellTemplate: require('./customCellTemplates/header.cell.template.html'),
        width: '25%'
      }],
      data: [],
      cannotGetNextBatchOfStores: this.cannotGetNextBatchOfStores,
      cannotGetPreviousBatchOfStores: this.cannotGetPreviousBatchOfStores,
      getPreviousBatchOfStores: this.getPreviousBatchOfStores,
      getNextBatchOfStores: this.getNextBatchOfStores,
      selectStore: this.selectStore,
      textFields: {
        selectStore: i18n.translate(localeKeys.STORE_INVENTORY_SEARCH_MODAL.SELECT_STORE),
        selected: i18n.translate(localeKeys.STORE_INVENTORY_SEARCH_MODAL.SELECTED)
      },
      onRegisterApi: onRegisterApi
    };
    this.$scope = $scope;
    this.currentSelectedIndex = 1;
    Object.assign(this, {
      localeKeys: localeKeys,
      gridOptions: gridOptions,
      storeGridActionConstants: STORE_GRID_ACTIONS,
      uiGridConstants: uiGridConstants
    });
  }
  return _createClass(StoreInventorySearchController, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.inventoryItems && changes.inventoryItems.previousValue && changes.inventoryItems.currentValue || changes.stores && changes.stores.previousValue && changes.stores.currentValue) {
        this.gridOptions.columnDefs = [{
          cellClass: 'first-column c-inventoryDetails',
          cellTemplate: require('./customCellTemplates/availability.cell.template.html'),
          field: 'physicalInventoryItem',
          firstColumn: true,
          headerCellTemplate: require('./customCellTemplates/header.cell.template.html'),
          width: '25%'
        }];
        this.gridOptions.data = [];
        this.setAssociatedTableData();
      }
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          isLoading: IsFetchingSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget)(function (state) {
        _this2.state = state;
      });
    }
  }, {
    key: "changeColumnDefs",
    value: function changeColumnDefs(direction) {
      var _this3 = this;
      if (direction === this.storeGridActionConstants.NEXT_BATCH_OF_STORES && this.cannotGetNextBatchOfStores()) {
        return;
      }
      if (direction === this.storeGridActionConstants.PREVIOUS_BATCH_OF_STORES && this.cannotGetPreviousBatchOfStores()) {
        return;
      }
      this.gridApi.grid.columns.forEach(function (columnToHide, index) {
        if (index === _this3.gridApi.grid.columns.length - 1 || index === 0) {
          return;
        }
        columnToHide.hideColumn();
      });
      if (direction === this.storeGridActionConstants.NEXT_BATCH_OF_STORES) {
        this.currentSelectedIndex += 3;
      }
      if (direction === this.storeGridActionConstants.PREVIOUS_BATCH_OF_STORES) {
        this.currentSelectedIndex -= 3;
      }
      this.gridApi.grid.columns.forEach(function (columnToHide, index) {
        if (_this3.currentSelectedIndex <= index && index <= _this3.currentSelectedIndex + 2) {
          columnToHide.showColumn();
        }
      });
      this.gridOptions.currentSelectedIndex = this.currentSelectedIndex;
      this.gridApi.core.notifyDataChange(this.uiGridConstants.dataChange.COLUMN);
    }
  }, {
    key: "onRegionChanged",
    value: function onRegionChanged(region) {
      this.selectedRegion = region;
      this.selectedStore = null;
      this.onRegionFilterChange()(this.selectedRegion);
    }
  }, {
    key: "cannotGetNextBatchOfStores",
    value: function cannotGetNextBatchOfStores() {
      return this.gridOptions.columnDefs.length - 1 <= this.currentSelectedIndex + 3;
    }
  }, {
    key: "cannotGetPreviousBatchOfStores",
    value: function cannotGetPreviousBatchOfStores() {
      return this.currentSelectedIndex <= 1;
    }
  }, {
    key: "getPreviousBatchOfStores",
    value: function getPreviousBatchOfStores() {
      this.changeColumnDefs(this.storeGridActionConstants.PREVIOUS_BATCH_OF_STORES);
    }
  }, {
    key: "getNextBatchOfStores",
    value: function getNextBatchOfStores() {
      this.changeColumnDefs(this.storeGridActionConstants.NEXT_BATCH_OF_STORES);
    }
  }, {
    key: "selectStore",
    value: function selectStore(store) {
      this.setSelectedStore()(store.field);
    }
  }, {
    key: "setAssociatedTableData",
    value: function setAssociatedTableData() {
      var _this4 = this;
      if (!this.inventoryItems || !this.stores) {
        return;
      }
      var storeHasAllItems = {};
      this.inventoryItems.forEach(function (invItem) {
        var formattedInvItem = clone(invItem);
        var formattedInvItemAvailability = {};
        formattedInvItem.stores.forEach(function (store) {
          formattedInvItemAvailability[store.storeId] = store.MeetsRequestedQuantity;
          if (storeHasAllItems[store.storeId] === undefined) {
            storeHasAllItems[store.storeId] = store.MeetsRequestedQuantity;
          } else {
            storeHasAllItems[store.storeId] = storeHasAllItems[store.storeId] && store.MeetsRequestedQuantity ? true : false;
          }
        });
        _this4.gridOptions.data.push(Object.assign(formattedInvItem, {
          targetAvail: formattedInvItemAvailability
        }));
      });
      this.stores.forEach(function (store, index) {
        var cellClasses = ['c-inventoryStoreAvailability'];
        var formattedStore = clone(store);
        var selectedStore = _this4.selectedStore;
        var isStoreSelected = selectedStore && selectedStore.Value === store.storeId ? true : false;
        if (isStoreSelected) {
          cellClasses.push('is-store-selected');
        }
        _this4.gridOptions.columnDefs.push(Object.assign(formattedStore, {
          cellClass: cellClasses.join(' '),
          cellTemplate: require('./customCellTemplates/availability.cell.template.html'),
          field: store.storeId,
          hasAllItems: storeHasAllItems[store.storeId],
          headerCellTemplate: require('./customCellTemplates/header.cell.template.html'),
          isStoreSelected: isStoreSelected,
          visible: index < 3 ? true : false,
          width: '20%'
        }));
      });
      this.addLastColumn();
      this.updateStoreGridColumns();
    }
  }, {
    key: "addLastColumn",
    value: function addLastColumn() {
      this.gridOptions.columnDefs.push({
        cellClass: 'last-column',
        cellTemplate: require('./customCellTemplates/availability.cell.template.html'),
        field: 'pseudoColumn',
        headerCellTemplate: require('./customCellTemplates/header.cell.template.html'),
        lastColumn: true,
        width: '*'
      });
    }
  }, {
    key: "updateStoreGridColumns",
    value: function updateStoreGridColumns() {
      if (!this.isInitialized && this.gridApi) {
        this.gridApi.core.notifyDataChange(this.uiGridConstants.dataChange.COLUMN);
      } else if (this.gridApi) {
        this.isInitialized = true;
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.isInitialized = false;
    }
  }]);
}();
export default {
  bindings: {
    hasError: '<',
    onClose: '&',
    onRegionFilterChange: '&',
    onRetry: '&',
    setSelectedStore: '&',
    inventoryItems: '<',
    isLoading: '<',
    regions: '<',
    selectedRegion: '<?',
    selectedStore: '<?',
    stores: '<'
  },
  template: require('./store.inventory.search.template.html'),
  controller: StoreInventorySearchController,
  controllerAs: 'StoreInventorySearch'
};